import { createSlice } from "@reduxjs/toolkit";
import _ from "lodash";

const initialState = {
  searchBarValue: "",
  filteringServices: [],
  filteringPermissions: {},
  myApiKeysRefetch: null,
};

const ApiKeysSlicer = createSlice({
  name: "apiKeysSlicer",
  initialState,
  reducers: {
    setSearchBarValue: (state, action) => {
      const newSearch = action?.payload;
      if (typeof newSearch !== "string") return;
      state.searchBarValue = newSearch;
    },

    setFilteringService: (state, action) => {
      const service = action.payload;
      if (typeof service !== "string") return;
      state.filteringServices.push(service);
    },

    removeFilteringService: (state, action) => {
      const service = action.payload;
      if (typeof service !== "string") return;
      state.filteringServices = state.filteringServices.filter(
        (i) => i !== service
      );
    },

    setFilteringPermissions: (state, action) => {
      const { service, permissions } = action.payload;
      if (![service, permissions].every((i) => typeof i === "string")) return;

      if (!_.isPlainObject(state.filteringPermissions)) {
        state.filteringPermissions = {};
      }

      if (_.has(state.filteringPermissions, service)) {
        state.filteringPermissions[service] = _.uniq([
          ...state.filteringPermissions[service],
          permissions,
        ]);
      } else {
        _.set(state.filteringPermissions, service, [permissions]);
      }
    },
    removeFilteringPermission: (state, action) => {
      const { service, permissions } = action.payload;

      if (![service, permissions].every((i) => typeof i === "string")) return;

      if (
        _.isPlainObject(state.filteringPermissions) &&
        _.has(state.filteringPermissions, service)
      ) {
        const updated = _.without(
          state.filteringPermissions[service],
          permissions
        );
        if (updated.length === 0) {
          _.unset(state.filteringPermissions, service);
        } else {
          state.filteringPermissions[service] = updated;
        }
      }
    },
    setMyApiKeysRefetch: (state, action) => {
      const refetch = action.payload;
      if (typeof refetch !== "function") return;
      state.myApiKeysRefetch = refetch;
    },
  },
});

export const {
  setSearchBarValue,
  setFilteringService,
  removeFilteringService,
  setFilteringPermissions,
  removeFilteringPermission,
  setMyApiKeysRefetch,
} = ApiKeysSlicer.actions;

export default ApiKeysSlicer.reducer;
